var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.313 9.671a1.25 1.25 0 00-1.292 0L2.81 11.006a.25.25 0 01-.373-.271l.587-2.515a1.25 1.25 0 00-.399-1.229L.671 5.298a.25.25 0 01.142-.438l2.572-.218a1.25 1.25 0 001.045-.758L5.436 1.51a.25.25 0 01.46 0l1.007 2.374c.181.427.583.719 1.045.758l2.572.218a.25.25 0 01.142.438L8.708 6.991A1.25 1.25 0 008.31 8.22l.587 2.515a.25.25 0 01-.373.27l-2.21-1.334z",
    fill: "#fff",
    stroke: "#6F6F6F"
  })));
}
export default SvgEmptyStar;